module.exports = __webpack_public_path__ + "img/Call.0be1e24e.svg";